












import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsLink from "@/design-system/components/Link/JdsLink.vue"
import JdiDocs from "@/components/JdiDocs.vue"
@Component({
    components: {JdiDocs, JdsLink, JdiPreview, JdiContent}
})
export default class Link extends Vue {
}
